import React from 'react';
import { Box, Typography, Paper } from '@mui/material';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import TrendingFlatIcon from '@mui/icons-material/TrendingFlat';
import TrendingDownIcon from '@mui/icons-material/TrendingDown';
import { useTranslation } from 'react-i18next';

const TREND_CONFIG = {
  'improving': {
    icon: TrendingUpIcon,
    color: '#4caf50',
    bg: '#e8f5e9',
  },
  'stable': {
    icon: TrendingFlatIcon,
    color: '#1976d2',
    bg: '#e3f2fd',
  },
  'declining': {
    icon: TrendingDownIcon,
    color: '#ff9800',
    bg: '#fff3e0',
  },
};

/**
 * TrendIndicator - Displays security posture trend
 * @param {string} label - Trend label text
 * @param {string} description - Trend description
 * @param {string} trend - Trend direction (improving, stable, declining)
 */
export const TrendIndicator = ({ label, description, trend = 'stable' }) => {
  const { t } = useTranslation('transparency');
  const config = TREND_CONFIG[trend] || TREND_CONFIG['stable'];
  const Icon = config.icon;

  return (
    <Paper
      elevation={0}
      sx={{
        p: 3,
        borderRadius: 2,
        bgcolor: config.bg,
        border: `1px solid ${config.color}22`,
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
        <Box
          sx={{
            width: 48,
            height: 48,
            borderRadius: '50%',
            bgcolor: 'white',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
          }}
        >
          <Icon sx={{ color: config.color, fontSize: 28 }} />
        </Box>
        <Box>
          <Typography variant="h6" fontWeight={600} sx={{ color: config.color }}>
            {label || t('public.defaultPostureLabel')}
          </Typography>
          {description && (
            <Typography variant="body2" color="text.secondary">
              {description}
            </Typography>
          )}
        </Box>
      </Box>
    </Paper>
  );
};
